import React from 'react';
import './css/style.css';
import button_submit_arrow from './img/button_submit_arrow.svg';

export default class Page extends React.Component {
    onClickGo() {
        window.location.href = 'https://fridn.com/';
    }

    render() {
        const aitxt = this.props.aitxt;
        return (
            <div className="s2_group">
                <p className="s2_group_title">
                    <span>{aitxt[16]}</span>
                </p>
                <div className="wrapper">
                    {
                        /*<div className="wrap wrap-1">
                        <div className="field">
                            <p className="field_title">Номер кошелька</p>
                            <input type="text" name="" className="field_input wallet_number" />
                        </div>
                    </div>*/
                    }
                    <ul className="instruction">
                        <li className="instruction_item">{aitxt[31]}</li>
                        <li className="instruction_item">{aitxt[32]}</li>
                        <li className="instruction_item">{aitxt[33]}</li>
                        <li className="instruction_item">{aitxt[34]}</li>
                    </ul>
                    <div className="commission">
                        <span className="commission_alert">{aitxt[24]}</span>
                        <p className="commission_desc">{aitxt[35]}</p>
                    </div>
                    {
                        /*<div className="info">
                        <div className="checkbox">
                            <input type="checkbox" className="check_info" id="checkbox_3" />
                            <label className="check_info_label" htmlFor="checkbox_3">I read terms&conditions</label>
                        </div>
                        </div>*/
                    }

                    <div className="buttons_block">
                        <button className="button button_go_to" onClick={this.onClickGo}>{aitxt[30]}
                            <span><img src={button_submit_arrow} alt="go" /></span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
